import React from 'react';
import { Grid, TextField, MenuItem } from '@mui/material';

interface Country {
  code: string;
  name: string;
  cities: string[];
}

interface CountryCitySelectorProps {
  country: string;
  setCountry: (val: string) => void;
  city: string;
  setCity: (val: string) => void;
  countries: Country[];
  cities: string[];
}

const CountryCitySelector: React.FC<CountryCitySelectorProps> = ({ country, setCountry, city, setCity, countries, cities }) => (
  <>
    <Grid item xs={12} sm={6}>
      <TextField
        select
        fullWidth
        label="Country"
        value={country}
        onChange={e => setCountry(e.target.value)}
        required
      >
        {countries.map((countryItem) => (
          <MenuItem key={countryItem.code} value={countryItem.code}>
            {countryItem.name}
          </MenuItem>
        ))}
      </TextField>
    </Grid>
    <Grid item xs={12} sm={6}>
      <TextField
        select
        fullWidth
        label="City"
        value={city}
        onChange={e => setCity(e.target.value)}
        required
        disabled={!country}
      >
        {cities.map((cityName) => (
          <MenuItem key={cityName} value={cityName}>
            {cityName}
          </MenuItem>
        ))}
      </TextField>
    </Grid>
  </>
);

export default CountryCitySelector; 